import lib from '@/library'
import Vue from 'vue'

const state = {
  liveEvents: [],
  liveEventsLoaded: false,
  localClockOffsetInSeconds: 0
}

const getters = {
  liveEvents (state) {
    return state.liveEvents
  },
  liveEventsLoaded (state) {
    return state.liveEventsLoaded
  },
  localClockOffsetInSeconds (state) {
    return state.localClockOffsetInSeconds || 0
  }
}

const mutations = {
  setLiveEventsLoaded (state, isLoaded) {
    state.liveEventsLoaded = isLoaded
  },
  resetLiveEvents (state) {
    state.liveEvents.splice(0, state.liveEvents.length)
  },
  addLiveEvent (state, liveEvent) {
    state.liveEvents.push(liveEvent)
  },
  deleteLiveEvent (state, idfoevent) {
    var eventToDelete = state.liveEvents.find(event => event.idfoevent === idfoevent)

    if (eventToDelete) {
      let index = state.liveEvents.indexOf(eventToDelete)
      if (index > -1) {
        state.liveEvents.splice(index, 1)
      }
    }
  },
  addMarketsForLiveEvent (state, request) {
    var event = state.liveEvents.find(evt => evt.idfoevent === request.idfoevent)

    if (event) {
      if (!event.markets) {
        Vue.set(event, 'markets', [])
      }

      request.markets.forEach((market) => {
        Vue.set(market, 'eventname', event.eventname)
        event.markets.push(market)
      })
    }
  },
  replaceMarketsForLiveEvent (state, request) {
    var event = state.liveEvents.find(evt => evt.idfoevent === request.idfoevent)

    if (event) {
      if (!event.markets) {
        Vue.set(event, 'markets', [])
      } else {
        event.markets.splice(0, event.markets.length)
      }

      request.markets.forEach((market) => {
        Vue.set(market, 'eventname', event.eventname)
        event.markets.push(market)
      })
    }
  },
  removeMarketFromLiveEvent (state, request) {
    var event = state.liveEvents.find(evt => evt.idfoevent === request.idfoevent)

    if (event && event.markets) {
      var marketToDelete = event.markets.find(mk => mk.idfomarket === request.idfomarket)

      if (marketToDelete) {
        var index = event.markets.indexOf(marketToDelete)

        if (index > -1) {
          event.markets.splice(index, 1)
        }
      }
    }
  },
  replaceMarketForLiveEvent (state, market) {
    var event = state.liveEvents.find(evt => evt.idfoevent === market.idfoevent)

    if (event && event.markets) {
      var marketToUpdate = event.markets.find(mk => mk.idfomarket === market.idfomarket)

      if (marketToUpdate) {
        marketToUpdate = market
      }
    }
  },
  addEventTimer (state, timer) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === timer.idfosbevent)

    if (event) {
      if (!event.timers) {
        Vue.set(event, 'timers', [])
      }

      event.timers.push(timer)
    }
  },
  updateEventTimer (state, timer) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === timer.idfosbevent)

    if (event && event.timers) {
      let timerToUpdate = event.timers.find(t => t.idfosbtimer === timer.idfosbtimer)

      if (timerToUpdate) {
        timerToUpdate = timer
      }
    }
  },
  removeEventTimer (state, timer) {
    var event = state.liveEvents.find(ev => ev.timers && ev.timers.filter(t => t.idfosbtimer === timer.idfosbtimer).length > 0)

    if (event && event.timers) {
      var timerToDelete = event.timers.find(t => t.idfosbtimer === timer.idfosbtimer)

      if (timerToDelete) {
        var index = event.timers.indexOf(timerToDelete)

        if (index > -1) {
          event.timers.splice(index, 1)
        }
      }
    }
  },

  addEventCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)

    if (event) {
      if (!event.counter) {
        Vue.set(event, 'counter', [])
      }

      event.counter.push(counter)
    }
  },
  addLeadCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)
    var lead = event.player && event.player.find(p => p.idfosblead === counter.idfosblead)

    if (lead) {
      if (!lead.counters) {
        Vue.set(lead, 'counters', [])
      }

      lead.counters.push(counter)
    }
  },
  updateEventCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)

    if (event && event.counter) {
      let counterToUpdate = event.counter.find(c => c.idfosbcounter === counter.idfosbcounter)

      if (counterToUpdate) {
        counterToUpdate = counter
      }
    }
  },
  updateLeadCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)

    if (event && event.player) {
      let playerForCounter = event.player.find(p => p.idfosblead === counter.idfosblead)

      if (playerForCounter) {
        let counterToUpdate = playerForCounter.counters.find(c => c.idfosbcounter === counter.idfosbcounter)

        if (counterToUpdate) {
          counterToUpdate = counter
        }
      }
    }
  },
  removeEventCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)

    if (event && event.counter) {
      var counterToDelete = event.counter.find(c => c.idfosbcounter === counter.idfosbcounter)

      if (counterToDelete) {
        var index = event.counter.indexOf(counterToDelete)

        if (index > -1) {
          event.counter.splice(index, 1)
        }
      }
    }
  },
  removeLeadCounter (state, counter) {
    var event = state.liveEvents.find(evt => evt.idfosbevent === counter.idfosbevent)

    if (event && event.player) {
      let player = event.player.find(p => p.idfosblead === counter.idfosblead)

      if (player) {
        let counterToDelete = player.counters.find(c => c.idfosbcounter === counter.idfosbcounter)

        if (counterToDelete) {
          let index = player.counters.indexOf(counterToDelete)

          if (index > -1) {
            player.counters.splice(index, 1)
          }
        }
      }
    }
  },

  setLocalClockOffsetInSeconds (state, offset) {
    state.localClockOffsetInSeconds = offset
  }
}

const actions = {
  calculateLocalClockOffsetInSeconds (context) {
    lib.kansas.oracleecho({
      dummy: 'time'
    }).then((response) => {
      if (response.data.DatabaseTime || response.data.DatabaseTime) {
        var nowTime = (new Date()).getTime()
        var oracleTime = (new Date(response.data.ServerTime)).getTime()
        var difference = Math.floor((oracleTime - nowTime) / 1000)

        context.commit('setLocalClockOffsetInSeconds', difference || 0)
      }
    }).catch(
      function (e) {
        console.log(e)
      }
    )
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/livebetting.js